// extracted by mini-css-extract-plugin
module.exports = {"img":"Image_img_34gOl","circle":"Image_circle_xpsFv"};